import { render } from "./BoardItem.vue?vue&type=template&id=54af8730&scoped=true"
import script from "./BoardItem.vue?vue&type=script&lang=ts"
export * from "./BoardItem.vue?vue&type=script&lang=ts"

import "./BoardItem.vue?vue&type=style&index=0&id=54af8730&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54af8730"

export default script